/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { Operator } from './Operator';
import {
    OperatorFromJSON,
    OperatorFromJSONTyped,
    OperatorToJSON,
} from './Operator';

/**
 * The filter term. Null if this is not a leaf but an inner Node
 * @export
 * @interface FilterRow
 */
export interface FilterRow {
    /**
     * 
     * @type {Array<Message>}
     * @memberof FilterRow
     */
    messages?: Array<Message>;
    /**
     * 
     * @type {number}
     * @memberof FilterRow
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterRow
     */
    name: string;
    /**
     * 
     * @type {Operator}
     * @memberof FilterRow
     */
    operator?: Operator;
    /**
     * 
     * @type {string}
     * @memberof FilterRow
     */
    propertyId?: string;
    /**
     * 
     * @type {any}
     * @memberof FilterRow
     */
    value?: any;
}

/**
 * Check if a given object implements the FilterRow interface.
 */
export function instanceOfFilterRow(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function FilterRowFromJSON(json: any): FilterRow {
    return FilterRowFromJSONTyped(json, false);
}

export function FilterRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messages': !exists(json, 'messages') ? undefined : ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'index': !exists(json, 'index') ? undefined : json['index'],
        'name': json['name'],
        'operator': !exists(json, 'operator') ? undefined : OperatorFromJSON(json['operator']),
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function FilterRowToJSON(value?: FilterRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messages': value.messages === undefined ? undefined : ((value.messages as Array<any>).map(MessageToJSON)),
        'index': value.index,
        'name': value.name,
        'operator': OperatorToJSON(value.operator),
        'propertyId': value.propertyId,
        'value': value.value,
    };
}

